import { AppUser } from '@/types';
import { createContext } from 'react';

interface AuthContextProps {
  user: AppUser | null;
  isLoading: boolean;
  isUserVerified: boolean;
}

export const AuthContext = createContext<AuthContextProps | undefined>(undefined);
